<template lang="pug">
  #network-container.container-fluid
    #networkChart
    #network-tooltip
    p#center {{selectedJournalist["Nombre"]}}
</template>
<script>
import * as d3 from "d3"

export default {
  name: "NetworkChart",
  data() {
    return {
      colors: {
        "Estado": "#fd7c30",
        "Municipio": "#1a6ba8",
        "Partido municipal": "#fc0f1c",
        "Publicación": "#973a4e",
        "Plataforma": "#42cb1f"
      },
      width: 600,
      height: 600,
      nodes: [],
      links: [],
      clusters: []
    }
  },
  computed: {
    allJournalists() {
      return this.$store.state.allJournalists;
    },
    selectedJournalist: {
      get() {
        return this.$store.state.selectedJournalist;
      },
      set(newValue) {
        this.$store.state.selectedJournalist = newValue;
      }
    }
  },
  watch: {
    selectedJournalist: async function (newValue) {
      await this.drawNetwork();
    }
  },
  methods: {
    getNodes(selection, allOthers) {
      const all = allOthers.slice();
      const state = selection["Estado de asesinato"],
            mun = selection["Municipio de asesinato"],
            munparty = selection["Partido político Presidente municipal"],
            media = selection["Medio"],
            platform = selection["Plataforma"],
            name = selection["Nombre"];
      
      const nodes = [];
      all.forEach(j => {
        const otherstate = j["Estado de asesinato"],
              othermun = j["Municipio de asesinato"],
              othermunparty = j["Partido político Presidente municipal"],
              othermedia = j["Medio"],
              otherplatform = j["Plataforma"],
              mediaIntersect = [media, othermedia].reduce((m, o) => m.filter(x => o.includes(x))),
              platformIntersect = [platform, otherplatform].reduce((m, o) => m.filter(x => o.includes(x) && x != ''));

        let node = j;  
        node.group = [];
        node.id = j["Nombre"];
        if (otherstate == state && state && state.length > 0) node.group.push("Estado");
        if (othermun == mun && mun && mun.length > 0) node.group.push("Municipio");
        if (othermunparty == munparty && munparty && munparty.length > 0) node.group.push("Partido municipal");
        if (mediaIntersect.length > 0) node.group.push("Publicación");
        if (platformIntersect.length > 0) node.group.push("Plataforma");
        if (node.group.length > 0 && node.id !== name) {  
          nodes.push(node);
        }
      });
      nodes.unshift({group: [], id: selection["Nombre"]});
      return nodes;
    },
    getLinks() {
      const nodes = this.nodes.slice();
      this.links = [];
      nodes.forEach(n => {
        for (let i = 0; i < n.group.length; i++) {
          const link = {
            source: nodes[0].id,
            target: n.id,
            value: n.group[i]
          }
          this.links.push(link);
        }
      });
      //console.log('sdhbbhsdbcdhjbcds',this.links, nodes, this.nodes.slice(0));
      //const nodes = this.nodes.slice();
      //this.links = [];
      //console.log('nodes:', nodes);
  
      /* nodes.forEach((n, i) => {
        let childNodes = [];
        if (i > 0) childNodes = this.getNodes(n, this.nodes.slice(i + 1));
        else childNodes = this.nodes.slice();
        console.log('others',childNodes,n,i);
        childNodes.forEach(n => {
          for (let i = 0; i < n.group.length &&  n.group.length > 1; i++) {
            const link = {
              source: childNodes[0].id,
              target: n.id,
              value: n.group[i]
            }
            this.links.push(link);
          }
        });
        console.log(this.links, 'links');
      }); */

    },
    async networkData() {
      this.nodes = await this.getNodes(this.selectedJournalist, this.allJournalists);
      let cluster = new Set();
      this.nodes.forEach(el => cluster = new Set([...cluster, ...el.group]));
      this.clusters = Array.from(cluster);
      this.getLinks();
      //console.log('links', this.links);
    },
    async drawNetwork() {
      await this.networkData();
      this.width = document.getElementById('network-container').clientWidth - 30;
      this.height = document.getElementById('network-container').clientWidth - 30;
      const links = this.links,
            nodes = this.nodes,
            radius = 12,
            coordinates = this.radialPlacement(nodes);
      const simulation = d3.forceSimulation(nodes)
        .force("link", d3.forceLink(links).id(d => d.id))
        .force("charge", d3.forceManyBody().strength((d, i) => i == 0 ? -50000 : -50))
        .force("center", d3.forceCenter(this.width / 2, this.height / 2))
        .force('collision', d3.forceCollide().radius(d => radius +1));

      d3.selectAll('#networkChart svg').remove();
      let svg = d3.select('#networkChart').append('svg')
        .attr('width', this.width)
        .attr('height', this.height);

      const link = svg.append("g")
          .attr("stroke", "#999")
          .attr("stroke-opacity", 0.6)
        .selectAll("line")
        .data(links)
        .join("line")
          .attr("stroke-width", "2")
          .attr("stroke", d => this.colors[d.value])
          .attr("class",d => "links " + "l" + d.target.index)
          .style("opacity","0.8");

      const wholeNode = svg.selectAll(".nodes")
        .data(nodes)
        .enter()
        .append("g")
          .attr("class", "nodes");

      const node = wholeNode.append("circle")
          .attr("r", (d, i) => i == 0 ? 60 : radius)
          .attr("fill", "#920D00")
          .attr("stroke", "white")
          .attr("stroke-width", "1px")
          .attr("id", (d, i) => i == 0 ? d.id : d["Nombre"])
          .attr("class", (d, i) => i == 0 ? "parent" : "children")
          .on("mouseover", function(d,i) {
            if (i == 0) return;
            d3.select(this)
              .style("fill","#913830")
              .attr("r", 14);

            let tooltip = d3.select('#network-tooltip');
            tooltip.transition()		
              .duration(200)
              .style("opacity", "1")
              .style("display","block")
              .style("position", "absolute")
              .style("zIndex", "1")
              .style("top", () => {
                return (d3.event.pageY -15) + "px";
              })
              .style("left", () => {
                return (d3.event.layerX + 15) + "px";
              });
            let content = `<p>`
            content += `${d["Nombre"]}<hr></p>`
            content += `<p>${d.group.join(', ')}`
            content += `</p>`;
            tooltip.html(content);

            d3.selectAll(".l" + d.index)
              .style("opacity","1")
              .attr("stroke-width", "3");
          })
          .on("mouseout", (d, i) => {
            if (i == 0) return;
            d3.selectAll(".children")
              .style("fill","#920D00")
              .attr("r", 12);

            let tooltip = d3.select('#network-tooltip')
              .transition()		
              .duration(100)
              .style("opacity", "0")
              .style("zIndex", "-1")
              .style("display","none");

            d3.selectAll(".links")
              .style("opacity","0.8")
              .attr("stroke-width", "2");
          })
          .on("click", (d, i) => {
            if (i == 0) return;
            let tooltip = d3.select('#network-tooltip')
              .style("opacity", "0")
              .style("zIndex", "-1")
              .style("display","none");
            const clearJournalist = Object.create(d);
            delete clearJournalist.vx;
            delete clearJournalist.vy;
            delete clearJournalist.x;
            delete clearJournalist.y;
            delete clearJournalist.index;
            delete clearJournalist.id;
            delete clearJournalist.group;
            this.selectedJournalist = clearJournalist;
          });

      const vm = this;
      simulation.on("tick", function() {
        //console.log('ticked', this.alpha(), nodes[0]);
        let alpha = this.alpha();
        
        // draw with simulation
        nodes.forEach((n, i) => {
          if (i > 0) {
            const k = alpha * 0.1;
            const centerNode = coordinates[n.group[0]];
            n.x += (centerNode.x - n.x) * k
            n.y += (centerNode.y - n.y) * k
          }
          else { n.x = vm.width / 2; n.y = vm.width / 2 }
        });

        node
          .attr("cx", (d, i) => d.x)
          .attr("cy", (d, i) =>  d.y);
          
        // links are drawn til the end of the simulation
        if (alpha < 0.35) {
          this.stop();
          vm.setParentLabel();
          link
            .attr("x1", d => {
              if (d.target.group.length == 1) return d.source.x;
              const index = d.target.group.indexOf(d.value);
              return d.source.x + index * 7;
            })
            .attr("y1", d => {
              if (d.target.group.length == 1) return d.source.y;
              const index = d.target.group.indexOf(d.value);
              return d.source.y + index * 5;
            })
            .attr("x2", d => {
              if (d.target.group.length == 1) return d.target.x;
              const index = d.target.group.indexOf(d.value);
              return d.target.x ;
            })
            .attr("y2", d => {
              if (d.target.group.length == 1) return d.target.y;
              const index = d.target.group.indexOf(d.value);
              return d.target.y + index * 5;
            });
        }
      });

      // uncomment if drag n drop is active
      //invalidation.then(() => simulation.stop());
      return svg.node();
    },
    setParentLabel() {
      const parent = d3.select('.parent');
      /* const name = d3.select('#networkChart svg').append("text")
          .attr('x', () => {return parent.attr('cx') - 46})
          .attr('y', () => {return parent.attr('cy') - 10})
          .style('fill','white')
          .style('font-size','13px')
          .style('pointer-events','none')
          .text(() => { 
            const totalNames = parent.attr('id').split(' ');
            const name = (totalNames[0] ? totalNames[0] : '') + ' ' + (totalNames[1] ? totalNames[1] : '');
            return name; });

       name.append("tspan")
          .attr('x', () => parent.attr('cx') - 46)
          .attr('y', () => Number.parseFloat(parent.attr('cy')) + 4)
          .text(() => { 
            const totalNames = parent.attr('id').split(' ');
            const name = (totalNames[2] ? totalNames[2] : '') + ' ' + (totalNames[3] ? totalNames[3] : '');
            return name; }); */

      d3.select('#center')
        .style("top", parent.attr('cy') - 20 + 'px')
        .style("left", Number.parseFloat(parent.attr('cx')) - 18 + 'px');
    },
    radialPlacement(arr) {
      const keys = this.clusters.map(c => {
        return {
          key: c,
          values: arr.slice(1).filter(el => el.group[0] == c)
        }
      }).filter(k => k.values.length > 0);
      const center = [this.width / 2, this.height / 2],
            clusterStep = 360 / (keys.length),
            step = 7,
            radius = 230;

      let coordinates = {},
          current = -120;

      //console.log('before j',arr, keys);
      // cluster placement
      keys.forEach((k, i) => {
        let x = center[0] + radius *  Math.cos(current * Math.PI / 180);
        let y = (center[1] + radius * Math.sin(current * Math.PI / 180))
        coordinates[k.key] = {x: x, y: y, angle: current, values: k.values.map(v => v.id)};

        current += clusterStep;
      })
      
      //console.log(arr, coordinates);
      return coordinates;
    }
  },
  mounted() {
    if (window.innerWidth >= 768) this.drawNetwork();
    window.onresize = () => {
      if (window.innerWidth >= 768) this.drawNetwork();
    }
  }
}
</script>
<style lang="scss" scoped>
#network-container {
  width: 100%;
  height: 100%;
}
#center {
  color: #fff;
  font-size: 12px;
  max-width: 100px;
  position: absolute;
  max-height: 110px;
  text-overflow: ellipsis;
  text-align: center;
}
</style>